import * as Sentry from '@sentry/nuxt'

import { applyTerminologyTokens } from '@/composables/useTerminology'

export default defineNuxtPlugin((nuxtApp) => {
  const i18n = nuxtApp.$i18n as any
  if (i18n) {
    i18n.missing = (locale: any, key: any, _vm: any, values: any) => {
      if (import.meta.client) {
        const warning = `[i18n-missing] Missing key: "${key}" for locale: "${locale}"`
        console.warn(warning)
        Sentry.captureException(warning, {
          level: 'warning',
          extra: {
            locale,
            key,
            values,
          },
        } as any)
      }
    }

    // Substitutes `:term(key)` / `:terms(key)` placeholders in any translated
    // string with the active account's custom terminology. See
    // `app/composables/useTerminology.ts`.
    i18n.setPostTranslationHandler?.((translated: unknown) =>
      typeof translated === 'string' ? applyTerminologyTokens(translated) : translated,
    )
  }
})
